import { render, staticRenderFns } from "./InternalRecipientIcon.vue?vue&type=template&id=2a927944"
import script from "./InternalRecipientIcon.vue?vue&type=script&lang=js"
export * from "./InternalRecipientIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports